import { render, staticRenderFns } from "./Clinic.vue?vue&type=template&id=6f217a21&scoped=true&"
import script from "./Clinic.vue?vue&type=script&lang=js&"
export * from "./Clinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f217a21",
  null
  
)

export default component.exports